/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Added_To_Group_SuccessInputs */



/**
* | output |
* | --- |
* | "User added to group successfully" |
*
* @param {Team_Manager_User_Added_To_Group_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_added_to_group_success = /** @type {((inputs?: Team_Manager_User_Added_To_Group_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Added_To_Group_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisateur ajouté au groupe avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer erfolgreich zur Gruppe hinzugefügt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utente aggiunto al gruppo con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользователь успешно добавлен в группу.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usuario añadido al grupo exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用户已成功添加到组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーがグループに正常に追加されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता को समूह में सफलतापूर्वक जोड़ दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usuário adicionado ao grupo com sucesso")
	return /** @type {LocalizedString} */ ("User added to group successfully")
});